import React, { useState } from 'react';

const ToggleViewButton = ({ viewMode, setViewMode }) => {
  const [activeTab, setActiveTab] = useState(viewMode || 'list');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (setViewMode) {
      setViewMode(tab);
    }
  };

  return (
    <div className="tab-container">
      <button
        className={`tab list ${activeTab === 'list' ? 'active' : ''}`}
        onClick={() => handleTabClick('list')}
        type="button"
      >
        List View
      </button>
      <button
        className={`tab map ${activeTab === 'map' ? 'active' : ''}`}
        onClick={() => handleTabClick('map')}
        type="button"
      >
        Map View
        <span className="new-icon">New</span>
      </button>
    </div>
  );
};

export default ToggleViewButton;
